(function () {
  'use strict';

  var COLOR_FIELDSET_INDEX = '0';
  var SIZE_FIELDSET_INDEX = '1';

  function getColorInputs(section) {
    return Array.from(
      section.querySelectorAll(
        'variant-picker [data-fieldset-index="' + COLOR_FIELDSET_INDEX + '"] input[type="radio"]'
      )
    );
  }

  function getSizeInputs(section) {
    return Array.from(
      section.querySelectorAll(
        'variant-picker [data-fieldset-index="' + SIZE_FIELDSET_INDEX + '"] input[type="radio"]'
      )
    );
  }

  function unlockViewport(sw) {
    if (sw && !sw.hasAttribute('in-viewport')) {
      sw.setAttribute('in-viewport', '');
    }
  }

  function revealGallery(gallery) {
    if (!gallery) return;
    gallery.style.opacity = '';
    gallery.style.transition = '';
  }

  /* After clicking a color, if the current size+color combo is invalid,
   * the variant-picker marks the size input as disabled/unavailable.
   * This function finds the first valid size and clicks it so the
   * section always re-renders with a real variant (never null). */
  function ensureValidVariant(section) {
    var sizeInputs = getSizeInputs(section);
    if (!sizeInputs.length) return;

    // Find the currently selected size input
    var checkedSize = null;
    for (var i = 0; i < sizeInputs.length; i++) {
      if (sizeInputs[i].checked) { checkedSize = sizeInputs[i]; break; }
    }
    if (!checkedSize) return;

    // Check if the checked size is now disabled/unavailable for the new color
    var isDisabled = (
      checkedSize.disabled ||
      checkedSize.getAttribute('aria-disabled') === 'true' ||
      (checkedSize.closest('label') && checkedSize.closest('label').classList.contains('disabled')) ||
      (checkedSize.closest('label') && checkedSize.closest('label').classList.contains('variant-disabled')) ||
      (checkedSize.closest('label') && checkedSize.closest('label').classList.contains('unavailable')) ||
      (checkedSize.closest('[data-value]') && checkedSize.closest('[data-value]').classList.contains('disabled'))
    );

    if (!isDisabled) return; // current size works — nothing to do

    // Find the first available size for the new color
    for (var j = 0; j < sizeInputs.length; j++) {
      var inp = sizeInputs[j];
      var label = inp.closest('label') || inp.closest('[data-value]');
      var available = (
        !inp.disabled &&
        inp.getAttribute('aria-disabled') !== 'true' &&
        (!label || (
          !label.classList.contains('disabled') &&
          !label.classList.contains('variant-disabled') &&
          !label.classList.contains('unavailable')
        ))
      );
      if (available) {
        inp.click();
        break;
      }
    }
  }

  function changeColor(section, direction) {
    var inputs = getColorInputs(section);
    var currentIndex = -1;
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].checked) { currentIndex = i; break; }
    }
    if (currentIndex < 0) return;
    var nextIndex = currentIndex + direction;
    if (nextIndex < 0 || nextIndex >= inputs.length) return;
    inputs[nextIndex].click();

    // Give the variant-picker time to update disabled states,
    // then auto-select a valid size if the current one is unavailable
    setTimeout(function() { ensureValidVariant(section); }, 30);
  }

  /* ── Direct swipe detector (for single-slide galleries) ──
   * Tracks pointerdown → pointerup horizontally.
   * Swipe left (dx < -40) → next color
   * Swipe right (dx > 40) → previous color
   */
  function setupDirectSwipe(gallery, section) {
    var startX = 0;
    var startY = 0;
    var tracking = false;

    gallery.addEventListener('pointerdown', function (e) {
      if (e.target.closest('button, a')) return; // ignore taps on controls
      startX = e.clientX;
      startY = e.clientY;
      tracking = true;
    });

    gallery.addEventListener('pointerup', function (e) {
      if (!tracking) return;
      tracking = false;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      if (Math.abs(dx) < 40) return;                      // too short
      if (Math.abs(dy) > Math.abs(dx) * 0.75) return;    // too vertical
      if (dx < 0) {
        changeColor(section, 1);   // swipe left → next color
      } else {
        changeColor(section, -1);  // swipe right → prev color
      }
    });

    gallery.addEventListener('pointercancel', function () { tracking = false; });
  }

  /* ── Arrow buttons for single-slide: both are always at boundary ── */
  function setupArrowsSingle(sw, section) {
    sw.addEventListener('pointerdown', function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      var btn = target.closest('[ref="next"],[ref="previous"]');
      if (!btn) return;
      var ref = btn.getAttribute('ref');
      if (ref === 'next') {
        changeColor(section, 1);
      } else if (ref === 'previous') {
        changeColor(section, -1);
      }
    });
  }

  /* ── Arrow boundary detection for multi-slide galleries ── */
  function setupArrowsMulti(sw, section) {
    sw.addEventListener('pointerdown', function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      var btn = target.closest('[ref="next"],[ref="previous"]');
      if (!btn) return;
      var ref = btn.getAttribute('ref');
      if (ref === 'next' && sw.atEnd) {
        changeColor(section, 1);
      } else if (ref === 'previous' && sw.atStart) {
        changeColor(section, -1);
      }
    });
  }

  /* ── Drag boundary detection for multi-slide galleries ── */
  function setupDragMulti(sw, section) {
    var lastDeltaX = 0;
    var lastPointerX = 0;

    sw.addEventListener('pointermove', function (event) {
      lastDeltaX = event.clientX - lastPointerX;
      lastPointerX = event.clientX;
    });

    sw.addEventListener('pointerdown', function (event) {
      lastPointerX = event.clientX;
      lastDeltaX = 0;
    });

    sw.addEventListener('slideshow:select', function (event) {
      var detail = event.detail;
      if (!detail.userInitiated) return;
      if (detail.trigger !== 'drag') return;
      var slides = sw.slides;
      if (!slides || !slides.length) return;
      if (detail.index !== detail.previousIndex) return;
      var lastSlide = slides.length - 1;
      if (detail.index === lastSlide && lastDeltaX < -5) {
        changeColor(section, 1);
        return;
      }
      if (detail.index === 0 && lastDeltaX > 5) {
        changeColor(section, -1);
      }
    });
  }

  function setupGallery(gallery, section) {
    if (gallery._swipeSyncSetup) return;
    gallery._swipeSyncSetup = true;

    var sw = gallery.querySelector('slideshow-component');
    if (!sw) return;

    unlockViewport(sw);

    var slideCount = gallery.querySelectorAll('slideshow-slide').length;

    if (slideCount <= 1) {
      /* Single image per variant — direct swipe + always-active arrows */
      setupDirectSwipe(gallery, section);
      setupArrowsSingle(sw, section);
    } else {
      /* Multiple images per variant — boundary detection */
      setupArrowsMulti(sw, section);
      setupDragMulti(sw, section);
    }
  }

  function initSection(section) {
    var safetyTimer = null;

    function cancelSafety() {
      if (safetyTimer) { clearTimeout(safetyTimer); safetyTimer = null; }
    }

    var observer = new MutationObserver(function (mutations) {
      for (var mi = 0; mi < mutations.length; mi++) {
        var added = mutations[mi].addedNodes;
        for (var ni = 0; ni < added.length; ni++) {
          var node = added[ni];
          if (!node || node.nodeType !== 1) continue;
          if (node.nodeName.toLowerCase() !== 'media-gallery') continue;
          cancelSafety();
          setupGallery(node, section);
          revealGallery(node);
          break;
        }
      }
    });
    observer.observe(section, { childList: true, subtree: true });

    var initialGallery = section.querySelector('media-gallery');
    if (initialGallery) {
      setupGallery(initialGallery, section);
    }

    section.addEventListener('change', function (event) {
      var inputs = getColorInputs(section);
      if (inputs.indexOf(event.target) < 0) return;
      cancelSafety();
    }, true);
  }

  function init() {
    document.querySelectorAll('.shopify-section').forEach(function (section) {
      if (section.querySelector('media-gallery') && section.querySelector('variant-picker')) {
        initSection(section);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();